import { useState } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  siteSettingObject,
  save,
  update,
  deleteLive,
  deletePreview,
  publish,
  getPreview,
  getLive,
} from "../../network/lib/siteSetting.js";
import { Link } from "react-router-dom";

function SiteSetting({ user }) {
  const [tagLine, setTageLine] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [watermarkImage, setWatermarkImage] = useState("");
  const [brightColor, setBrightColor] = useState("");
  const [lightColor, setLightColor] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  const setToDefault = () => {
    setTageLine("");
    setBannerImage("");
    setWatermarkImage("");
    setBrightColor("");
    setLightColor("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setTageLine(params.tagLine);
      setBannerImage(params.bannerImage);
      setWatermarkImage(params.watermarkImage);
      setBrightColor(params.brightColor);
      setLightColor(params.lightColor);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (tagLine == "") {
      message.innerHTML = "Please provide TagLine";
    } else {
      showHideLoader(true);

      siteSettingObject.id = id;
      siteSettingObject.tagLine = tagLine;
      siteSettingObject.bannerImage = bannerImage;
      siteSettingObject.watermarkImage = watermarkImage;
      siteSettingObject.brightColor = brightColor;
      siteSettingObject.lightColor = lightColor;
      siteSettingObject.userName = user.userName;

      if (id == 0) {
        save(siteSettingObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(siteSettingObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = () => {
    showHideLoader(true);

    getPreview()
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchPreviewData();
  };

  const fetchLiveData = () => {
    showHideLoader(true);

    getLive()
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchLiveData();
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        siteSettingObject.id = parseInt(params);
        siteSettingObject.userName = user.userName;

        deletePreview(siteSettingObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        siteSettingObject.id = parseInt(params);
        siteSettingObject.userName = user.userName;

        deleteLive(siteSettingObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      siteSettingObject.id = parseInt(params);
      siteSettingObject.userName = user.userName;

      publish(siteSettingObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData();
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleBannerImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setBannerImage);
  };

  const handleWatermarkImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setWatermarkImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Profile Setting
            </th>
          </tr>
          <tr>
            <td colSpan={4} align="right">
              <Link to="/admin/slider">
                <span>Slider Image Activity</span>
              </Link>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Marquee Tagline</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="105" />
                )}
                value={tagLine}
                onChangeText={(text) => {
                  setTageLine(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Banner Image</span>
            </td>
            <td>
              <label
                htmlFor="banner-file-upload"
                className="custom-file-upload"
                style={{ width: "307px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="banner-file-upload"
                accept="image/*"
                onChange={(e) => handleBannerImage(e)}
              />
            </td>
            <td colSpan={2}>
              {bannerImage && (
                <img
                  src={bannerImage}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Watermark Image</span>
            </td>
            <td>
              <label
                htmlFor="watermark-file-upload"
                className="custom-file-upload"
                style={{ width: "307px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="watermark-file-upload"
                accept="image/*"
                onChange={(e) => handleWatermarkImage(e)}
              />
            </td>
            <td colSpan={2}>
              {watermarkImage && (
                <img
                  src={watermarkImage}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Bright Color</span>
            </td>
            <td>
              <input
                type="color"
                value={brightColor}
                onChange={(e) => setBrightColor(e.target.value)}
                style={{ width: "323px" }}
              />
            </td>
            <td align="right">
              <span>Light Color</span>
            </td>
            <td>
              <input
                type="color"
                value={lightColor}
                onChange={(e) => setLightColor(e.target.value)}
                style={{ width: "323px" }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "34px" }}
            >
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 8 : approver ? 7 : 6}>
                Preview
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 8 : approver ? 7 : 6}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              {publisher && (
                <td>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Tag Line</u>
              </td>
              <td>
                <u>Banner Image</u>
              </td>
              <td>
                <u>Watermark Image</u>
              </td>
              <td>
                <u>Bright Color</u>
              </td>
              <td>
                <u>Light Color</u>
              </td>
              <td>
                <u>Edit</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  {publisher && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.tagLine}</td>
                  <td>
                    {x.bannerImage &&
                      parse(`<img src=${x.bannerImage} style="width: 60px" />`)}
                  </td>
                  <td>
                    {x.watermarkImage &&
                      parse(
                        `<img src=${x.watermarkImage} style="width: 60px" />`
                      )}
                  </td>
                  <td>{x.brightColor}</td>
                  <td>{x.lightColor}</td>
                  <td>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 8 : approver ? 7 : 6}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 6 : 5}>
                Live
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 6 : 5}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              <td>
                <u>Tag Line</u>
              </td>
              <td>
                <u>Banner Image</u>
              </td>
              <td>
                <u>Watermark Image</u>
              </td>
              <td>
                <u>Bright Color</u>
              </td>
              <td>
                <u>Light Color</u>
              </td>
              {admin && (
                <td>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  <td>{x.tagLine}</td>
                  <td>
                    {x.bannerImage &&
                      parse(`<img src=${x.bannerImage} style="width: 60px" />`)}
                  </td>
                  <td>
                    {x.watermarkImage &&
                      parse(
                        `<img src=${x.watermarkImage} style="width: 60px" />`
                      )}
                  </td>
                  <td>{x.brightColor}</td>
                  <td>{x.lightColor}</td>
                  {admin && (
                    <td>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 6 : 5} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default SiteSetting;
